import { Alert, AlertLevel } from 'common/components/notifications/types';
import { supportArticleForExplanations } from 'common/services/api/apiConstants';
import { tl } from 'common/services/i18nService';
import { SemanticICONS } from 'semantic-ui-react';
import { FileUploadInfo } from '../store/common/constants';

const successAlertDefaultProps = {
    info: '',
    level: AlertLevel.SUCCESS,
    icon: 'check circle' as SemanticICONS,
    delay: 3000,
};

const getAlertLinkDetails = () => ({
    text: tl('grading.uploadGradeAndExplanation.viewDocumentation'),
    url: supportArticleForExplanations,
    nonLinkText: tl('grading.uploadGradeAndExplanation.moreDetails'),
});

const getUploadFailedInstructions = () => [
    tl('grading.uploadGradeAndExplanation.failed.sentMessage'),
    tl('grading.uploadGradeAndExplanation.failed.setMessage'),
];

const notificationService = {
    predefinedAlertNotifications: {
        markUploadSuccess: (numberOfCandidatesWithScoresImported: string, numberOfCandidatesWithScoresNotImported: string): Alert => ({
            ...successAlertDefaultProps,
            key: tl('grading.uploadMark.uploaded'),
            info: tl('grading.uploadMark.infoMessage', {
                numberOfCandidatesWithScoresImported,
                numberOfCandidatesWithScoresNotImported,
            }),
        }),
        gradeUploadSuccess: (): Alert => ({
            ...successAlertDefaultProps,
            key: tl('grading.uploadGrade.uploaded'),
        }),
        uploadSuccess: (gradeORmarks: FileUploadInfo.GRADE | FileUploadInfo.MARKS): Alert => ({
            ...successAlertDefaultProps,
            key: tl(`grading.upload${gradeORmarks}AndExplanation.uploaded`),
        }),
        uploadSuccessWithNote: (setORsent: FileUploadInfo.SET | FileUploadInfo.SENT): Alert => ({
            key: tl('grading.uploadGradeAndExplanation.uploadedWithNote.title'),
            info: tl(`grading.uploadGradeAndExplanation.uploadedWith${setORsent}Note.info`),
            link: getAlertLinkDetails(),
            level: AlertLevel.INFO,
        }),
        uploadSuccessWithNoteFailed: (): Alert => ({
            key: tl('grading.uploadGradeAndExplanation.uploadedWithNote.title'),
            info: tl('grading.uploadGradeAndExplanation.failed.info'),
            instructions: getUploadFailedInstructions(),
            link: getAlertLinkDetails(),
            level: AlertLevel.INFO,
        }),
        uploadFailed: (): Alert => ({
            key: tl('grading.uploadGradeAndExplanation.failed.title'),
            info: tl('grading.uploadGradeAndExplanation.failed.info'),
            instructions: getUploadFailedInstructions(),
            link: getAlertLinkDetails(),
            level: AlertLevel.WARNING,
            icon: 'exclamation triangle' as SemanticICONS,
        }),
        fileError: (type: string): Alert => ({
            key: tl(`grading.uploadFile.${type}.title`),
            info: tl(`grading.uploadFile.${type}.info`),
            link: getAlertLinkDetails(),
            level: AlertLevel.WARNING,
            icon: 'exclamation triangle' as SemanticICONS,
        }),
    },
};

export default notificationService;
